module.exports = __webpack_public_path__ + "media/A Thousand Years.fe1d8237.mp3";